import { Component, OnInit } from '@angular/core';
import { CacheService } from '../services/cache.service';
import { Router } from '@angular/router';
import { ConstantsService } from '../services/constants.service';

@Component({
  selector: 'app-gift-success',
  templateUrl: './gift-success.component.html',
  styleUrls: ['./gift-success.component.scss']
})
export class GiftSuccessComponent implements OnInit {
  from = "giftCheckOut";
  constructor(private cacheService: CacheService, private router: Router, public constants: ConstantsService) { }

  ngOnInit(): void {
    let paymentStatus = this.cacheService.getGiftPayment();
    if (paymentStatus) {
      this.cacheService.setGiftPayment(false);
    } else {
      this.router.navigate(['/']);
    }
  }

}
